export default [
    {
        path: 'exame-imagem',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-exame-imagem' */
            '@/views/pronto-atendimento/atendimento-exame-imagem/Index'
        ),
        redirect: 'exame-imagem/index',
        children: [
            {
                name: 'pronto-atendimento-exame-imagem-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-exame-imagem' */
                    '@/views/pronto-atendimento/atendimento-exame-imagem/List.vue'
                ),
            },
            {
                name: 'pronto-atendimento-exame-imagem-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-exame-imagem' */
                    '@/views/pronto-atendimento/atendimento-exame-imagem/Form.vue'
                ),
            },
            {
                name: 'pronto-atendimento-exame-imagem-edit',
                path: 'edit/:id/:plantaoId',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-exame-imagem' */
                    '@/views/pronto-atendimento/atendimento-exame-imagem/Form.vue'
                ),
            }
        ]
    }
]